import { useQuery } from '@tanstack/react-query'
import { getContainerDetails } from '@/api/containersAPI'
import { IContainer } from '../interfaces/interfaces'

export const useContainerDetails = (containerId?: number) => {
  const { data: containerDetails, isLoading, error } = useQuery({
    queryKey: ['container_details', containerId],
    queryFn: () => getContainerDetails(containerId as number),
    enabled: Boolean(containerId),
    staleTime: 5 * 60 * 1000, // 5 minutes cache
  })

  return {
    containerDetails,
    isLoading,
    error,
  }
} 